import { BrowsingContextError } from '../../browsingContextError';
import { getGlobalDocument } from './global';

/** Provides a temporary DOM that is then serialized to HTML. */
export function htmlFromDom(callback: (document: Document, element: HTMLElement) => Node | void): string {
  const globalDocument = getGlobalDocument();
  if (!globalDocument) {
    throw new BrowsingContextError();
  }

  const temporaryDocument = globalDocument.implementation.createHTMLDocument();
  const temporaryElement = temporaryDocument.createElement('div');

  const resultNode = callback(temporaryDocument, temporaryElement);
  if (resultNode) {
    temporaryElement.appendChild(resultNode);
  }

  return temporaryElement.innerHTML;
}
